import styled from 'styled-components';

interface Props {
   theme: any;
   color?: string;
   margin?: string;
}

const ToolTip = styled.small`
   color: ${({ theme, color = theme.primaryGrey }: Props) => color};
   display: inline-block;
   margin: ${({ margin = '0' }: Props) => margin};
`;

export default ToolTip;
